import { VehicleModelType } from '../enums';
import { isPeakSeason } from './peak-season.constant';
/**
 * 반려동물 동반 예약 시 차량료 인상률.
 * 현재 정책: 반려동물 동반 차량료를 일반 차량료와 동일하게 적용(인상률 0%).
 * (이전: 비수기 +2% / 성수기 +5% — 재적용이 필요하면 값만 되돌리면 됩니다)
 *
 * ⚠️ 별도 옵션비가 아니라 "차량료 자체"에 적용되는 인상률입니다.
 */
export const PET_PRICE_ADJUSTMENT_RATE = {
    NORMAL: 0,
    PEAK: 0,
};
/**
 * 반려동물 동반 예약이 불가능한 차종.
 * (슈퍼카 / 수입차는 펫 동반 경로에서 제외)
 */
export const PET_INELIGIBLE_VEHICLE_TYPES = [
    VehicleModelType.SUPERCAR,
    VehicleModelType.IMPORTED,
];
/** 반려동물 동반 가능 차량 연식 범위 (양끝 포함). */
export const PET_ELIGIBLE_MIN_MODEL_YEAR = 2020;
export const PET_ELIGIBLE_MAX_MODEL_YEAR = 2024;
/**
 * 차량(모델)이 반려동물 동반 예약 가능 대상인지 판정합니다.
 *
 * - 차종이 슈퍼카/수입차가 아니어야 하고,
 * - 모델의 연식 범위가 2020~2024년식 안에 완전히 포함(min>=2020 && max<=2024)되어야 합니다.
 *
 * minModelYear/maxModelYear는 해당 모델에 속한 실제 차량들의 연식(Vehicle.age)
 * MIN/MAX 집계값입니다. 정확한 개별 차량 연식은 배차 후 ERP에서 확인합니다.
 */
export const isPetEligibleVehicle = (params) => {
    const { type, minModelYear, maxModelYear } = params;
    if (PET_INELIGIBLE_VEHICLE_TYPES.includes(type)) {
        return false;
    }
    return (minModelYear >= PET_ELIGIBLE_MIN_MODEL_YEAR &&
        maxModelYear <= PET_ELIGIBLE_MAX_MODEL_YEAR);
};
/**
 * 반려동물 동반 예약에 적용할 차량료 인상률을 반환합니다. (단일 진입점)
 *
 * - 펫 동반 예약이 아니거나(`isWithPet=false`) 차량이 적격이 아니면 0
 * - 적격 + 성수기 → 0.05 (5%)
 * - 적격 + 비/평수기 → 0.02 (2%)
 *
 * 가격 계산/예약 생성/스냅샷 등 모든 곳에서 이 함수를 사용해 일관성을 보장합니다.
 */
export const getPetPriceRate = (params) => {
    const { isWithPet, type, minModelYear, maxModelYear, pickUpAt } = params;
    if (!isWithPet) {
        return 0;
    }
    if (!isPetEligibleVehicle({ type, minModelYear, maxModelYear })) {
        return 0;
    }
    return isPeakSeason(pickUpAt)
        ? PET_PRICE_ADJUSTMENT_RATE.PEAK
        : PET_PRICE_ADJUSTMENT_RATE.NORMAL;
};
